import { Button, Icon } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../components/TableContent';
import { TableContentItemStatus } from '../../../../components/TableContent/status';
import { messageError } from '../../../../store/batchTicket/constants';
import { tableHeadBatchTicketRequestsData } from '../../utils';

import { ResponsiveItemCustomerProps } from '.';

export const DesktopItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  detailsButtonIsDisabled,
  handlePressDetailsButton,
  detailsButtonColor,
}) => {
  return (
    <TableContent direction="row">
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[0].flex}>
        <TableContentItemText variant="semibold">
          {item.basketOrderHash || messageError}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[1].flex}>
        <TableContentItemText>{item.createDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[2].flex}>
        <TableContentItemText>{item.applicationType}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[3].flex}>
        <TableContentItemText>{item.totalCustomers}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[4].flex}>
        <TableContentItemText>{item.totalOffers}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[5].flex}>
        <TableContentItemText>{item.totalRequestedAmountFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[6].flex}>
        <TableContentItemText>{item.updateDateFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[7].flex}>
        <TableContentItemStatus basketAdvisorStatus={item.basketAdvisorStatus} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={tableHeadBatchTicketRequestsData[8].flex}>
        <Button
          variant="textLink"
          rightIcon={<Icon name="ChevronRight" size="xxxs" color={Color[detailsButtonColor]} />}
          isDisabled={detailsButtonIsDisabled}
          onPress={handlePressDetailsButton}
          _text={{ fontFamily: Typography['fontfamily.base.semibold'], color: detailsButtonColor }}>
          Detalhes
        </Button>
      </TableContentItemColumn>
    </TableContent>
  );
};
